import { API_MEDIA } from '@/helpers/globalVars'

export function getMediaUrl (path?: string) {
  if (!path) return ''
  if (process.env.NODE_ENV === 'development' && path.startsWith('/')) return path
  if (path.startsWith('http') || path.startsWith('//')) return path
  return `${API_MEDIA.replace(/\/+$/, '')}/${path.replace(/^\/+/, '')}`
}
